<!-- Property of OSF Global Services, Inc., (with its brand OSF Commerce). OSF remains the sole owner of all right, title and interest in the software. Do not copy, sell, reverse engineer or otherwise attempt to derive or obtain information about the functioning, manufacture or operation therein. -->
<style scoped>
.row {
    width: 100%;
    overflow: hidden;
    display: block;
    margin: 0;
}

#mainQWrap {
    position: relative;
    min-height: 18.75rem;
    text-align: center;
    width: 100%;
    box-sizing: border-box;
}

.quizTopCTAs {
    padding: 0;
    margin: 0;
    overflow: hidden;
    width: 100%;
}

.stepIndicator {
    margin-top: 2.5rem 0 1.25rem 0;
    float: left;
    min-width: 25%;
    max-width: 100%;
    padding: 0 1.875rem;
    height: 3.125rem;
    display: flex;
    flex: wrap;
    justify-content: center;
    align-items: center;
    font-family: Roboto;
    font-size: 1.125rem;
    font-weight: 500;
    text-align: center;
    color: #fff;
    box-sizing: border-box;
}

.stepIndicator.progress {
    float: right;
    min-width: 9.375rem;
    border-radius: 0;
}

.stepIndicator.unanswered {
    background-color: #7e7885;
}

.stepIndicator.answered.answereddisabled {
    cursor: initial;
}

.stepIndicator.active.answered {
    cursor: initial;
}

.tabs {
    background-color: #5f4c54;
}

.tabs .tabs__icon {
    color: #ffffff;
}
</style>

<template>
    <div>
        <!-- Question Body Container -->
        <div class="row">
            <div
                id="mainQWrap"
                ref="quizbody"
                v-bind:style="
                    question && question.image != ''
                        ? {
                              'background-image': 'url(' + question.image + ')',
                              'background-size': 'cover',
                          }
                        : ''
                "
            >
                <smallloader v-show="smallloader && !error" />

                <div>
                    <template v-if="question && question.renderTemplate === 'Template1'">
                        <Q1Template />
                    </template>
                    <template v-else-if="question && question.renderTemplate === 'Template2'">
                        <Q2Template />
                    </template>
                    <template v-else-if="question && question.renderTemplate === 'Template3'">
                        <Q3Template />
                    </template>
                    <template v-else-if="question && question.renderTemplate === 'Template4'">
                        <Q4Template />
                    </template>
                    <template v-else-if="question && question.renderTemplate === 'Template5'">
                        <Q5Template />
                    </template>
                    <template v-else-if="question && question.renderTemplate === 'Template6'">
                        <Q6Template />
                    </template>
                    <template v-else-if="question && question.renderTemplate === 'Template7'">
                        <Q7Template />
                    </template>
                    <template v-else-if="question && question.renderTemplate === 'Template8'">
                        <Q8Template />
                    </template>
                    <template v-else-if="question && question.renderTemplate === 'Template9' && isVisible">
                        <Q9Template />
                    </template>
                    <template v-else-if="question && question.renderTemplate === 'Template10'">
                        <Q10Template />
                    </template>
                    <template v-else>
                        <Q1Template />
                    </template>

                    <navbuttons />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SmallLoaderComp from "./smallLoaderComponent.vue";
import NavButtonsComp from "./navButtonsComponent.vue";
import Q1Template from "./questionTemplates/q1.vue";
import Q2Template from "./questionTemplates/q2.vue";
import Q3Template from "./questionTemplates/q3.vue";
import Q4Template from "./questionTemplates/q4.vue";
import Q5Template from "./questionTemplates/q5.vue";
import Q6Template from "./questionTemplates/q6.vue";
import Q7Template from "./questionTemplates/q7.vue";
import Q8Template from "./questionTemplates/q8.vue";
import Q9Template from "./questionTemplates/q9.vue";
import Q10Template from "./questionTemplates/q10.vue";

export default {
    name: "QuestionBody",
    components: {
        smallloader: SmallLoaderComp,
        navbuttons: NavButtonsComp,
        Q1Template: Q1Template,
        Q2Template: Q2Template,
        Q3Template: Q3Template,
        Q4Template: Q4Template,
        Q5Template: Q5Template,
        Q6Template: Q6Template,
        Q7Template: Q7Template,
        Q8Template: Q8Template,
        Q9Template: Q9Template,
        Q10Template: Q10Template,
    },
    props: { question: Object },
    data: () => ({
        isVisible: false,
    }),
    computed: {
        quizData: function () {
            return this.$store.state.quizData;
        },
        smallloader: function () {
            return this.$store.state.smallLoading;
        },
        error: function () {
            return this.$store.state.errorShow;
        },
    },
    mounted: function () {
        this.observer = new IntersectionObserver(this.onObserved, {
            threshold: 0.6,
        });
        this.observer.observe(this.$refs.quizbody);
    },
    beforeDestroy: function () {
        this.observer.disconnect();
    },
    methods: {
        onObserved: function (entries) {
            // We have the only observed element - the element itself
            const currentElement = entries[0];
            this.isVisible = currentElement.isIntersecting;
        },
    },
};
</script>
